var _g, _g2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPlate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 183,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-plate_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.795 69.796l-51.589 29.927c-10.991 6.376-28.864 6.376-39.928 0L56.351 69.797c-5.567-3.207-8.348-7.42-8.336-11.624L48 64.13c-.012 4.204 2.768 8.415 8.333 11.624l51.929 29.927c11.062 6.376 28.935 6.376 39.926 0l51.592-29.927c5.459-3.168 8.193-7.313 8.203-11.463l.017-5.956c-.012 4.15-2.746 8.294-8.205 11.462z",
    fill: "#6c47ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-plate_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.665 46.71c11.062 6.374 11.12 16.71.13 23.086l-51.589 29.927c-10.991 6.375-28.864 6.377-39.928 0L56.351 69.797c-11.062-6.375-11.12-16.711-.13-23.088l51.589-29.927c10.991-6.376 28.866-6.376 39.928 0l51.927 29.927z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.171 49.678c-.826-2.004-5.666-2.004-6.492 0-.534 1.294-3.052 1.908-4.984 1.215-2.991-1.072-6.413.942-4.591 2.703 1.177 1.137.134 2.62-2.065 2.934-3.403.487-3.403 3.336 0 3.822 2.199.314 3.242 1.797 2.065 2.934-1.822 1.761 1.6 3.776 4.591 2.703 1.932-.693 4.45-.079 4.984 1.215.826 2.004 5.666 2.004 6.492 0 .534-1.294 3.053-1.908 4.985-1.215 2.99 1.073 6.413-.942 4.591-2.703-1.178-1.137-.134-2.62 2.064-2.934 3.403-.486 3.403-3.335 0-3.822-2.198-.314-3.242-1.797-2.064-2.934 1.822-1.76-1.601-3.775-4.591-2.703-1.932.693-4.451.08-4.985-1.215zm-3.246 12.613c3.612 0 6.54-1.724 6.54-3.85 0-2.126-2.928-3.85-6.54-3.85-3.611 0-6.539 1.724-6.539 3.85 0 2.126 2.928 3.85 6.539 3.85z",
    fill: "#6c47ff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-plate_svg__filter0_d",
    x: 0,
    y: 34.173,
    width: 256,
    height: 148.289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-plate_svg__filter1_d",
    x: 24.016,
    y: 0,
    width: 207.984,
    height: 140.505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default SvgLogoPlate;